import { getEntityType } from '@datorama/akita';
import {
  AbstractFeatureEntityState,
  AbstractFeatureEntityStore,
  AbstractFeatureQueryEntity,
  AbstractFeatureService,
  AbstractUserRelatedDataService,
} from '@y42/feature';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { AbstractFeatureGitService } from '@y42/feature/git';
import { AbstractGitEntityStore } from '@y42/feature/git/state';
import { GitQuery } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { LogModel } from '@y42/log';
import { Y42EntityStore } from '@y42/state';
import { ToastService } from '@y42/toast';
import { Observable } from 'rxjs';
import { FileTargetResponse, TriggerService } from '../trigger.service';

export abstract class ImpexService<
  S extends AbstractFeatureEntityState = AbstractFeatureEntityState,
  Entity extends getEntityType<S> = getEntityType<S>,
> extends AbstractFeatureService<S, Entity> {
  constructor(
    public readonly config: {
      featureType: Y42FeatureType;
      store: AbstractFeatureEntityStore<S>;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      query: AbstractFeatureQueryEntity<S, any>;
      git: AbstractFeatureGitService;
      acl?: AbstractFeatureAclService;
      userData: AbstractUserRelatedDataService<S> | null;

      gitQuery: GitQuery;
      toast: ToastService;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      childStores: Array<AbstractGitEntityStore<any, any, any> | Y42EntityStore<any, any, any>>;
    },
    protected readonly triggerService: TriggerService,
  ) {
    super(config);
  }

  getLogsForResource(logId: string): Observable<LogModel[]> {
    return this.triggerService.getLogsForResource(logId);
  }

  authorize<TResponse = unknown>(path: string, secret: Record<string, unknown>) {
    return this.triggerService.setCredentials<TResponse>(path, secret);
  }

  getFileTarget(orgId: number): Observable<FileTargetResponse> {
    return this.triggerService.getFileTarget(orgId);
  }

  abstract deleteAuthorization(): Promise<void>;
}
